<div class="modal-body">
    <h4>Leave a comment</h4>
    <form [formGroup]="form" autocomplete="off" (submit)="query()">
        <div class="row">
            <div class="col-md-12 mb-2">
                <textarea formControlName="reason" class="form-control custom-textarea"
                          placeholder="Type here..."></textarea>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-primary btn-sm float-right" type="submit">
                    Continue <i class="mdi mdi-arrow-right"></i>
                </button>
            </div>
        </div>
    </form>
</div>